/** Header-bridge event names, capability labels and slug helpers for the
 * workspace Bots section. Event names live here so both sides of the bridge
 * (UnifiedAppHeader and the section) import one string. */
import type { BotCapability, WorkspaceBot } from '../../../services/WorkspaceBotsService';

export const WORKSPACE_BOT_NEW_SLUG = 'new';

/** Section -> header sync. `null` on unmount. */
export const WORKSPACE_BOTS_STATE_EVENT = 'workspace-bots:state-change';
export interface WorkspaceBotsHeaderState {
  listVisible: boolean;
  searchQuery?: string;
  detailOpen: boolean;
  hasChanges: boolean;
  isSaving: boolean;
  botName: string | null;
}
/** Header -> section intents. */
export const WORKSPACE_BOTS_SEARCH_EVENT = 'workspace-bots:search';
export const WORKSPACE_BOTS_CREATE_EVENT = 'workspace-bots:create';
export const WORKSPACE_BOTS_SAVE_EVENT = 'workspace-bots:save';
export const WORKSPACE_BOTS_CANCEL_EVENT = 'workspace-bots:cancel';
export const WORKSPACE_BOTS_BACK_EVENT = 'workspace-bots:back';

export const BOT_CAPABILITY_OPTIONS: Array<{ value: BotCapability; label: string; hint: string }> = [
  { value: 'read_projects', label: 'Read projects and BOQs', hint: 'Search projects, project details and bill of quantities lines.' },
  { value: 'read_tasks', label: 'Read tasks', hint: 'List tasks by project, assignee, status or due date.' },
  { value: 'read_documents', label: 'Read documents', hint: 'List project documents by name. Contents are not read.' },
  { value: 'read_calendar', label: 'Read calendar', hint: 'The calendar of the person it is replying to.' },
  { value: 'create_tasks', label: 'Create tasks', hint: 'Create a task, optionally linked to a project and assignee.' },
  { value: 'message_members', label: 'Message a workspace member', hint: 'Send a direct message to someone in this workspace when asked to.' },
];

export function botSlug(name: string): string {
  const slug = name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['\u2019]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug || 'bot';
}

export function findBotBySlug(bots: WorkspaceBot[], slug: string): WorkspaceBot | null {
  const matches = bots.filter((b) => botSlug(b.name) === slug);
  return matches.find((b) => b.isEnabled) ?? matches[0] ?? null;
}
